import React from 'react';
import { useBasePageQuery, usePageOwner } from '../../hooks';
import { calendarIcon } from '@justgiving/icons';
import IconLabel from '../IconLabel/IconLabel';
import { formatDateValue } from '../../utils/formatDate';
import i18next from 'i18next';
import { DonationReminder } from '../DonationReminder/DonationReminder';

export const Activity: React.FC = () => {
  const { data } = useBasePageQuery();
  const { isPageOwner } = usePageOwner();

  if (!data?.page?.activity) {
    return null;
  }

  const getLabel = () => {
    if (!data.page?.activity) {
      return '';
    }

    const { name, date } = data.page.activity;

    if (!date) {
      return name;
    }

    return (
      <>
        {name}, {formatDateValue(new Date(date).getTime(), i18next.language)}
        {/* OTG 2023 - Tom Hedges */}
        {!isPageOwner && <DonationReminder />}
      </>
    );
  };

  return <IconLabel icon={calendarIcon} label={getLabel()} />;
};
